import * as St from './DesignSectionHeader.styles';

type DesignSectionHeaderProps = {
  children?: React.ReactNode;
  title: string;
  description: string;
  fontsize?: string;
  subtitleStyle?: React.CSSProperties;
};

const DesignSectionHeader = ({
  children,
  title,
  description,
  subtitleStyle,
}: DesignSectionHeaderProps) => (
  <St.Container>
    <St.Title>{title}</St.Title>
    <St.SubTitleContainer>
      <St.SubTitle style={subtitleStyle}>{description}</St.SubTitle>
      {children}
    </St.SubTitleContainer>
  </St.Container>
);

export default DesignSectionHeader;
